import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/switch/style";
import _Switch from "antd/lib/switch";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import ServiceBriefs from 'services/ServiceBriefs';
import ServiceChannels from 'services/ServiceChannels';

var SwitchStatus = function SwitchStatus(_ref) {
  var channel = _ref.channel,
      brief = _ref.brief;

  var _useState = useState(function () {
    if (channel) return (channel === null || channel === void 0 ? void 0 : channel.status) === 1;
    if (brief) return (brief === null || brief === void 0 ? void 0 : brief.status) === 1;
    return false;
  }),
      checked = _useState[0],
      setChecked = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var changeStatus = function changeStatus(active) {
    setLoading(true);
    console.log('🚀 ~ changeStatus ~ active', active);
    setChecked(active);

    if (channel) {
      ServiceChannels.status({
        channelUUID: channel.uuid,
        status: active ? 1 : 0
      }).then(function (channel) {
        setChecked(channel.status === 1);
      })["finally"](function () {
        setLoading(false);
      });
    }

    if (brief) {
      ServiceBriefs.status({
        briefUUID: brief.uuid,
        status: active ? 1 : 0
      }).then(function (brief) {
        setChecked(brief.status === 1);
      })["finally"](function () {
        setLoading(false);
      });
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: "SwitchStatus flewRow",
    children: /*#__PURE__*/_jsx(_Tooltip, {
      title: "Change status to ".concat(checked ? 'Offline' : 'Online'),
      children: /*#__PURE__*/_jsx(_Switch, {
        className: "SwitchToggle" //defaultChecked={channel?.status === 1}
        ,
        loading: loading,
        checked: checked // checkedChildren="Online"
        // unCheckedChildren="Offline"
        ,
        onChange: changeStatus
      })
    })
  });
};

export default SwitchStatus;